// From https://stackoverflow.com/a/35970186
const contrastColor = (color: string) => {
  if (color.indexOf("#") === 0) color = color.slice(1);
  if (color.length !== 6) throw new Error("Invalid HEX color.");

  var r = parseInt(color.slice(0, 2), 16),
    g = parseInt(color.slice(2, 4), 16),
    b = parseInt(color.slice(4, 6), 16);

  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
};

export { contrastColor };
